define([
    "dojo/_base/declare",
    "csi",
    "csi/form/Widget",
    "csi/locale",
    "csi/store/_base"
], function(declare,csi,Widget,locale,csiStore) {

    return declare(Widget, {

        FIELD_BOM: "BOM",
        FIELD_SELECTED_LINE_ITEM:"SelectedLineItem",

        getFieldStore: function(/*Field*/field, /*String*/value) {
            var name = field.getControlName();
            var store = this.inherited(arguments);

            if (name == this.FIELD_SELECTED_LINE_ITEM && this.getViewNode().LineItems.length > 1) {
                store.put(csiStore.nameObject(locale.resource("SelectAll")));
            }

            return store;

        },

        _updateFieldVisibility: function(/*Field?*/field) {
            this.setFieldHidden(this.defView.getField("BOM"), this.defView.getFieldValue(this.FIELD_SELECTED_LINE_ITEM) == csi.EMPTY_URL );
            return this.inherited(arguments);
        },

        _onDependency: function(/*Field*/field, /*Field*/fieldSource, /*Any?*/value) {
            if (fieldSource.getControlName() == this.FIELD_SELECTED_LINE_ITEM) {
                var lineItemURL = this.defView.getFieldValue(this.FIELD_SELECTED_LINE_ITEM);
                if(lineItemURL!= csi.EMPTY_URL) {
                    if((lineItem = this.cacheView.getNode(lineItemURL, true)) && (product = this.cacheView.getNode(lineItem.SRLineItemProduct, true))) {
                       value = product.AuthorityBOM;
                    }
                }
            }
            this.inherited(arguments, [field, fieldSource, value]);
        }

    });
});